import { createJustText, JustText } from '@vfde-brix/ws10/just-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { formatAddressText } from '../util/formatter';
import { Address, AvcResult } from '@vfde-sails/avc-core';
import { getAvcResultAlternativeText } from '../container/AvailabilityCheck/util/result';
import { mountComponent } from '../util/mount';

export const mountText = (wrapperId: HtmlId) =>
    mountComponent(wrapperId, createJustText, NO_PATTERN_BUSINESS_LOGIC);

export const updateAddressText = (comp?: JustText, address?: Address) =>
    comp?.update({ content: formatAddressText(address) });

export const updateAlternativeText = (comp: JustText | undefined, avcResult: AvcResult) => {
    const alternativeText = getAvcResultAlternativeText(avcResult.fastest);

    comp?.update({ content: alternativeText });
    comp?.toggleContainer(avcResult.selectedAvailable);
};
